<div class="main-container">
   <video id="bgVideo" autoplay loop muted playsinline preload="auto" class="video-background">
      <source src="assets/videos/landing_bg.mp4" type="video/mp4" />
      Your browser does not support the video tag.
   </video>
   <div class="container">
      <div class="module-container">
         <div class="empty">
            <ng-container *ngIf="!isSuperAdmin; else superAdmin">
               <!-- <div class="client-icon">
                  <img src="assets/images/aesthetics/client.svg" alt="Client Icon">
               </div> -->
               <div class="client-dropdown">
                  <div class="client-dropdown-study" (click)="hasSingleClient ? '' : openClientDropdown()" DocumentClick
                     (DocumentClicked)="this.isClientDropdown=false">
                     <div class="client-dropdown-study-txt"
                        [ngStyle]="{'font-style':ClientName!='Choose Client'?'normal':'italic'}">
                        <span>{{ClientName}}</span>

                     </div>
                     <div class="client-dropdown-study-img" *ngIf="!hasSingleClient && ClientName!=''">
                        <div class="client-dropdown-img"
                           [ngClass]="{ 'rotate-icon': isClientDropdown && uniqueClientNamescount>0 }"></div>

                     </div>

                  </div>
                  <div class="client-dropdown-list" [ngClass]="{'show' : isClientDropdown}">
                     <div class="custom-report-list-search"
                        [ngStyle]="{'display':uniqueClientNamescount>10?'flex':'none'}">
                        <div class="client-search-block" title="Search Client">
                           <input type="search" [(ngModel)]="Clientsearchtxt" class="search-input-client"
                              placeholder="Search  Client" (click)="$event.stopPropagation()">
                        </div>
                     </div>
                     <div class="client-dropdown-list-scroll">
                        <div class="client-dropdown-names"
                           *ngFor="let item of uniqueClientNames | search: Clientsearchtxt:['clientName']"
                           (click)="ClientNameclick(item.clientName)">
                           <span title="{{item.clientName}}"> {{item.clientName}} </span>
                        </div>

                     </div>

                  </div>


               </div>
            </ng-container>
            <ng-template #superAdmin>
               <div class="client-dropdown">
                  <div class="client-dropdown-study" (click)="openClientDropdown()" DocumentClick
                     (DocumentClicked)="this.isClientDropdown=false">
                     <div class="client-dropdown-study-txt"
                        [ngStyle]="{'font-style':ClientName!='Choose Client'?'normal':'italic'}">
                        <span>{{ClientName}}</span>

                     </div>
                     <div class="client-dropdown-study-img">
                        <div class="client-dropdown-img"
                           [ngClass]="{ 'rotate-icon': isClientDropdown && uniqueClientNamescount>0 }"></div>

                     </div>

                  </div>

                  <div class="client-dropdown-list" [ngClass]="{'show' : isClientDropdown}">
                     <div class="custom-report-list-search"
                        [ngStyle]="{'display':uniqueClientNamescount>10?'flex':'none'}">
                        <div class="client-search-block" title="Search Client">
                           <input type="search" [(ngModel)]="Clientsearchtxt" class="search-input-client"
                              placeholder="Search  Client" (click)="$event.stopPropagation()">
                        </div>
                     </div>
                     <div class="client-dropdown-list-scroll">
                        <div class="client-dropdown-names"
                           *ngFor="let item of uniqueClientNames | search: Clientsearchtxt:['clientName']"
                           (click)="ClientNameclick(item.clientName)">
                           <span title="{{item.clientName}}"> {{item.clientName}} </span>
                        </div>

                     </div>

                  </div>

               </div>
            </ng-template>


         </div>


         <div class="module-options">
            <div class="menu-item" *ngFor="let item of modules; let i = index"
               [ngStyle]="{'display':item.is_active?'flex':'none' }"
               [ngClass]="{'clickable': item.access, 'selected': item.is_selected}" (click)="moduleSelected(item)">
               <span class="text-overlay" [ngStyle]="{'color':item.is_selected?'#000':'#fff'}">{{
                  item.moduleName=='ARK'?'ASKME':item.moduleName|
                  uppercase
                  }}</span>
               <img src="../../../../assets/images/aesthetics/moduleHoverSelect.svg" alt="Hover Image"
                  class="hover-image" />
               <img *ngIf="item.is_selected" src="../../../../assets/images/aesthetics/moduleHoverSelect.svg"
                  class="click-image" />

            </div>

         </div>

      </div>

      <div class="sub-container">
         <div class="header">
            <div class="settings-icon" (click)="isSettingToggle = !isSettingToggle" DocumentClick
               (DocumentClicked)="isSettingToggle = false">
               <img
                  [src]="!isSettingToggle ? 'assets/images/aesthetics/settings_icon.svg' : 'assets/images/aesthetics/SettingsIcon-click.svg'"
                  alt="Settings Icon" [class.rotate]="isSettingToggle" />

            </div>
            <div class="settingDropdown" [ngClass]="{'show' : isSettingToggle, 'hide' : !isSettingToggle}">
               <ng-container *ngIf="isSettingToggle">
                  <ng-container *ngFor="let option of SettingList">
                     <div class="setting-option" *ngIf="option.hasAccess" (click)="onOptionClick(option.value)">
                        <img [src]="'assets/images/aesthetics/' + option.iconClass + '.svg'"
                           alt="option.displayLabel" />
                        <div class="settingOptionName"> {{ option.displayLabel }} </div>

                     </div>
                  </ng-container>
               </ng-container>

            </div>
         </div>
         <div class="sub-content">
            <div class="body" *ngIf="!isModuleSelected && !isModuleDirty">
               <div class="logo-block">
                  <div class="logo-sub-block">
                     <!-- <div class="logo-icon">
                        <img src="assets/images/aesthetics/spade_logo.svg" alt="Spade Icon" />
                     </div> -->
                     <div class="logo-txt">
                        <img src="assets/images/aesthetics/Exp_logo.svg" alt="Spade Text" />

                     </div>

                  </div>

               </div>
               <div class="logo-txt-block">
                  <div class="welcome-content">
                     <div class="welcome-txt">
                        Welcome back, <span class="username">{{userName}}</span>
                     </div>
                     <div class="static-txt" *ngIf="ClientName!='Choose Client'"><span class="text">
                           Choose a module from the side menu
                           to unlock powerful data and actionable insights.
                        </span>
                     </div>
                     <div class="static-txt" *ngIf="ClientName=='Choose Client'"><span class="text">
                           Choose a Client from the Left Corner
                           to unlock powerful data and actionable insights.
                        </span>
                     </div>
                  </div>
               </div>
            </div>
            <div class="moduleContent" *ngIf="isModuleSelected">
               <app-module-landing [moduleName]="moduleName" [studyNames]="studyNames" [ClientName]="ClientName"
                  [configData]="configData" [isSuperAdmin]="isSuperAdmin">
               </app-module-landing>
            </div>
         </div>
         <div class="footer">
            <div class="kantar-logo">
               <img src="assets/images/aesthetics/K_DSE_Logo.svg" alt="Kantar">
            </div>
         </div>
      </div>
   </div>
</div>